import React, { useState, useEffect } from "react";
import "./BlogsForm.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addBlogs, UploadBlogBodyImage, UploadFeatureImageUrl, getAllCategories } from "proxyUrl";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {BsFillImageFill} from 'react-icons/bs';
import CKEditorComponent from './CKEditorComponent';

const BlogsForm = () => {
  const [content, setContent] = useState();
  const [image, setImage] = useState({});
  const [submiteed, setSubmiteed] = useState(false);
  const [status, setStatus] = useState("1");
  const [preview, setPreview] = useState(null);
  const [categories, setCategories] = useState([]);
  const [slugManuallyEdited, setSlugManuallyEdited] = useState(false);
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };
  const handleImage = (e) => {
    setImage(e.target.files[0]);
    setPreview(URL.createObjectURL(e.target.files[0]));
  };
  const navigate = useNavigate();
  const [user, setUser] = useState({
    title: "",
    metadescription: "",
    slug: "",
    metakeywords: "",
    metatitle: "",
    alttext: "",
    canonical: "",
    category: "",
    shortDescription: "",
    type: "",
  });
  let name, value;
  const handleInput = (e) => {
    name = e.target.name;
    value = e.target.value;

    // If user edits slug directly, stop auto-generation
    if (name === "slug") {
      setSlugManuallyEdited(true);
    }

    setUser({ ...user, [name]: value });
  };

  // Generate URL-friendly slug from title
  const generateSlug = (title) => {
    return title
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "") // Remove special chars
      .replace(/[\s_-]+/g, "-") // Replace spaces/underscores with -
      .replace(/^-+|-+$/g, ""); // Trim - from start/end
  };

  // Auto-generate slug from title when title changes (if slug not manually edited)
  useEffect(() => {
    if (user.title && !slugManuallyEdited) {
      const autoSlug = generateSlug(user.title);
      setUser((prev) => ({
        ...prev,
        slug: autoSlug,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.title]);
  const sendData = async (e) => {
    e.preventDefault();
    if (
      !user.alttext ||
      !user.canonical ||
      !user.metakeywords ||
      !user.metadescription ||
      !user.slug ||
      !user.title ||
      !image
    ) {
      toast.error("please  the data!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    //creating form data
    const formData = new FormData();
    formData.append("image", image);

    await axios
      .post(UploadFeatureImageUrl, formData, {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          axios
            .post(
              addBlogs,
              {
                title: user.title,
                category: user.category,
                slug: user.slug,
                content: content,
                metakeywords: user.metakeywords,
                metadescription: user.metadescription,
                metatitle: user.metatitle,
                alttext: user.alttext,
                canonical: user.canonical,
                shortDescription: user.shortDescription,
                status: status,
                type: user.type,
                image: res.data.imageUrl,
              },
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              console.log(res.status);
              if (res.status === 200) {
                console.log("Form submiteed succsesfully");
                toast.success("Form submiteed succsesfully!", {
                  position: "top-center",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                const delayfrfresh = () => {
                  navigate("/admin/blogs");
                };
                // eslint-disable-next-line
                const delayRef = setTimeout(delayfrfresh, 3100);
              }
            })
            .catch((err) => {
              console.log(err.response.status);
              if (err.response.status === 400) {
                console.log("Please fill all data");
                toast.error("Please fill all data!", {
                  position: "top-center",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                const delay = () => {
                  setSubmiteed(false);
                };
                // eslint-disable-next-line
                const myTimeout = setTimeout(delay, 3000);
              } else {
                console.log("something went wrong");
                toast.error("something went wrong!", {
                  position: "top-center",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                const delay = () => {
                  setSubmiteed(false);
                };
                // eslint-disable-next-line
                const myTimeout = setTimeout(delay, 3000);
              }
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const tork = false;
  const [userPlace, setUserPlace] = useState({
    title: "Enter Blog Title",
    metadescription: "Enter Blog Meta Descrioption ",
    slug: "Enter Blog  slug ",
    content: "Enter Blog Content",
    metakeywords: "Enter Blog Metakeywords",
    metatitle: "Enter Blog Metatitle",
    alttext: "Enter Blog Alttext",
    canonical: "Enter Blog Canonical",
    Description: "Type Hare....",
  });

  if (tork === true) {
    setUserPlace(null);
  }

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(getAllCategories, {
        withCredentials: true,
      });
      if (res.data && res.data.data) {
        setCategories(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
      toast.error("Failed to load categories!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {}, [image]);
  return (
    <>
      <div className="mt-7  mb-2 rounded-lg bg-white shadow-xl dark:bg-navy-800 ">
        <div className="mx-auto w-[90%]  ">
          <form action="" method="POST" className="">
            <div className="">
              <div className="field w-[100%] ">
                <div className="input  relative">
                  <label htmlFor="title"> Title</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.title}`}
                    maxLength={80}
                    name="title"
                    value={user.title}
                    onChange={handleInput}
                  />
                </div>
                <div className="input relative">
                  <label htmlFor="slug" className="">
                    Slug
                  </label>
                  <input
                    type="text"
                    placeholder={`${userPlace.slug}`}
                    name="slug"
                    value={user.slug}
                    onChange={handleInput}
                  />
                </div>
              </div>

              <div className="field">
                <div className="input relative">
                  <label htmlFor="metakeywords"> Metakeywords</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.metakeywords}`}
                    name="metakeywords"
                    value={user.metakeywords}
                    onChange={handleInput}
                  />
                </div>
                <div className="input  relative ">
                  <label htmlFor="Metatitle"> Metatitle</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.metatitle}`}
                    name="metatitle"
                    value={user.metatitle}
                    onChange={handleInput}
                  />
                </div>
              </div>
              <div className="field">
                <div className="input relative ">
                  <label htmlFor="category"> Meta Description</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.metadescription}`}
                    name="metadescription"
                    value={user.metadescription}
                    onChange={handleInput}
                  />
                </div>

                <div className="input  relative ">
                  <label htmlFor="canonical">Canonical</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.canonical}`}
                    name="canonical"
                    value={user.canonical}
                    onChange={handleInput}
                  />
                </div>
              </div>
             
              <div className="field">
                <div className="input relative">
                  <label htmlFor="alttext"> Alttext</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.alttext}`}
                    name="alttext"
                    maxLength={80}
                    value={user.alttext}
                    onChange={handleInput}
                  />
                </div>
                <div className="input relative">
                  <label htmlFor="shortDescription">Short Description</label>
                  <input
                    className="h-[53px] overflow-hidden !rounded-md   "
                    id="shortDescription"
                    type="text"
                    value={user.shortDescription}
                    onChange={handleInput}
                    name="shortDescription"
                  />
                </div>
              </div>
              <div className="field">
                <div className="input relative">
                  <label htmlFor="status-select">Status:</label>
                  <select
                    id="status-select"
                    value={status}
                    onChange={handleStatusChange}
                  >
                    <option value="1">Active</option>
                    <option value="0">Disabled</option>
                  </select>
                </div>
                <div className="input relative">
                  <label htmlFor="type-select">Type:</label>
                  <select
                    id="type-select"
                    name="type"
                    value={user.type}
                    onChange={handleInput}
                  >
                    <option value="">Select Type</option>
                    <option value="1">Fliotravels</option>
                    <option value="2">Aoneff</option>
                    <option value="3">Parents Arena</option>
                  </select>
                </div>
              </div>
              <div className="field">
                <div className="input relative">
                  <label htmlFor="category-select"> Category</label>
                  <select
                    id="category-select"
                    name="category"
                    value={user.category}
                    onChange={handleInput}
                    className="mt-2"
                  >
                    <option value="">Select Category</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.slug}>
                        {category.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="field my-6">
                <div className="input relative mx-2 mr-7 flex items-center justify-center rounded-lg border-2 border-blueSecondary   ">
                  <div className=" h-[200px] w-[400px] rounded-lg ">
                    {preview ? (
                      <img
                        className="h-full w-full rounded-md object-cover "
                        src={preview}
                        alt=""
                      />
                    ) : (
                      <>
                      <div className=" w-full h-full text-8xl text-primaryBlue flex items-center justify-center ">
                        <BsFillImageFill/>
                      </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="input relative">
                  <label htmlFor="alttext">Uploade File</label>
                  <input
                    type="file"
                    name="file"
                    // value={user.alttext}
                    onChange={handleImage}
                  />
                </div>
              </div>
              <div className="relative mx-2">
                <h2 className="mb-1"> Content</h2>
                <div className="hidden">
                  <CKEditor
                    value={content}
                    editor={ClassicEditor}
                    placeholder={""}
                    data=""
                    onReady={(editor) => {}}
                    config={{
                      // plugins: [ Essentials ],
                      ckfinder: {
                        // The URL that the images are uploaded to.
                        // uploadUrl: "/upload",

                        // Enable the XMLHttpRequest.withCredentials property.
                        withCredentials: true,

                        // Headers sent along with the XMLHttpRequest to the upload server.
                        headers: {
                          "X-CSRF-TOKEN": "CSFR-Token",
                          Authorization: "Bearer <JSON Web Token>",
                        },
                        uploadUrl: "",
                      },
                    }}
                    // onInit={editor => {
                    //   editor.plugins.get("FileRepository").createUploadAdapter = loader => {
                    //     return new MyUploadAdapter(loader);
                    //   };
                    // }}
                    onChange={(handleInput, editor) => {
                      const data = editor.getData();
                      setContent(data);
                    }}
                  />
                </div>
                <CKEditorComponent
                  value={content}
                  onChange={setContent}
                />
                
              </div>
              {submiteed ? (
                <div className="field cursor-pointer ">
                  <div className=" my-5 rounded-md bg-gray-300 py-3 px-12 text-white">
                    <button disabled>Loading....</button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="field cursor-pointer " onClick={sendData}>
                    <div className=" my-5 rounded-md bg-primaryBlue py-3 px-12 text-white">
                      <button>Submit</button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default BlogsForm;
